<template>
  <span
    :class="{
      'form__draw--radio': isSingle,
      'form__draw--checkbox': isMultiple,
      'form__draw--input': isInput,
      'form__draw--picture': isPicture,
      'form__draw--other': isOther
    }"
    class="form__draw form__draw--radio mr-1-2 inline-block"
  />
</template>

<script>
// @flow
import {
  RADIO, CHECKBOX, INPUT, PICTURE, OTHER
} from '../../utils';

export default {
  props: {
    type: {
      type: String,
      default: ''
    }
  },
  computed: {
    isSingle() {
      return this.type === RADIO;
    },
    isMultiple() {
      return this.type === CHECKBOX;
    },
    isInput() {
      return this.type === INPUT;
    },
    isPicture() {
      return this.type === PICTURE;
    },
    isOther() {
      return this.type === OTHER;
    }
  }
};
</script>

<style lang="scss">
.form__draw {
  min-width: 1rem;
  min-height: 1rem;
  border: $border-width-default solid rgba($color-ui-black,$font-opacity-sm);
  transition: $transition-sm-slow $transition-easing-default;
  overflow: hidden;
  position: relative;
  &::after, &::before {
    content: '';
    position: absolute;
    opacity: 0;
    border: $border-width-default solid $color-ui-black;
    transition: opacity $transition-sm-slow $transition-easing-default;
  }
  &::after {
    height: 13px;
    width: 13px;
    transform: rotateZ(44deg) translate3d(8px, 2px, 0);
  }
  &::before {
    height: 4px;
    width: 4px;
    transform: translate3d(2px, 2px, 0);
    border-radius: $border-radius-circle;
  }
  &--radio {
    border-radius: .5rem;
  }
  &--checkbox, &--picture {
    border-radius: $border-radius-default;
  }
  &--input {
    min-height: 0;
    max-height: 0;
    min-width: 0;
    max-width: 0;
  }
  &--picture {
    &::after {
      opacity: $font-opacity-sm;
    }
    &::before {
      opacity: $font-opacity-sm;
    }
  }
  &--other {
    border-style: dashed;
    border-radius: 1px;
  }
}
</style>
